import { Typography } from 'antd';
import { ReceiptWorkspace } from '../receipt-workflow';
export type ReceiptPanelBizType = 'customer' | 'contract';
export function ReceiptPanel({
  title,
  bizType,
  bizUuid,
}: {
  title?: string;
  bizType: ReceiptPanelBizType;
  bizUuid: string;
}) {
  return (
    <div>
      {title && <Typography.Title level={5}>{title}</Typography.Title>}
      {bizUuid && (
        <ReceiptWorkspace
          key={`${bizType}:${bizUuid}`}
          embedded
          initialTab="plans"
          contractUuid={bizType === 'contract' ? bizUuid : undefined}
          customerUuid={bizType === 'customer' ? bizUuid : undefined}
        />
      )}
    </div>
  );
}
